import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-568d469c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "login-form" }
const _hoisted_3 = { class: "inputs" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white" }, " Please input your password to continue validation. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_TransparentButton = _resolveComponent("TransparentButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Input, {
          ref: "password",
          modelValue: _ctx.password,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
          title: "Password",
          placeholder: "Password",
          type: "password",
          required: true,
          "err-msg": 'Invalid Password'
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_TransparentButton, {
        class: "btn-login",
        text: "Validate",
        click: _ctx.validateContactMethod
      }, null, 8, ["click"])
    ])
  ]))
}